import { useResponsive } from '@/shared/helpers/responsiveness'

import { useEffect } from 'react'

/**
 * Locks `<body>` scroll while the mobile drawer is open. The lock is released
 * automatically when the viewport grows past the mobile breakpoint, when the
 * drawer closes, or when the component unmounts.
 *
 * NOTE: This is a simple save/restore on `document.body.style.overflow` and
 * can conflict with other components that also mutate it (e.g. a Dialog or
 * Drawer locking scroll concurrently). If multiple concurrent locks become
 * a real need, replace this with a shared lock counter pattern (e.g. a
 * `data-scroll-locked` counter on `<body>`) or delegate to a DS-level scroll
 * lock primitive.
 */
export const useLockScrollWhenOpen = (isOpen: boolean): void => {
  const isMobile = useResponsive('lg')

  useEffect(() => {
    if (!isOpen || !isMobile) return
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [isOpen, isMobile])
}
